import { render } from "./NewOptinSetup.vue?vue&type=template&id=95eaecea&scoped=true"
import script from "./NewOptinSetup.vue?vue&type=script&lang=js"
export * from "./NewOptinSetup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-95eaecea"

export default script